import store from "store2"

import shuffleSeed from 'shuffle-seed'

var current = -1

export default function(o, data, onStart){

  var imageSize = MaxResolution

  var slideshowStarted = false

  var markers = shuffleSeed.shuffle(data.markers)

  var next =
    function(){

      if(++current == markers.length){

        current = -1

      } else {

        var marker = markers[current]

        var startUrl = marker.start.replace(/:/g,'-')
        var imageFile = `omb_${marker.roll}_${imageSize}_${startUrl}.jpg`
        var imageUrl = o.util.getUrl('thumbAntiArchive',imageSize) + imageFile
        // var imageUrl = o.util.getUrl('thumb',imageSize) + imageFile

        var tmp = $('<img>')

        tmp.one('load', function(){
          // console.log('load', imageUrl);
          div.css({
            backgroundImage: `url(${imageUrl})`,
          })
          tmp = null
          if(!slideshowStarted){
            slideshowStarted = true
            if(onStart){
              onStart()
            }
          }
        })

        tmp.attr('src', imageUrl)

      }

      setTimeout(function(){
        if(div.is(':visible')){
          next()
        }
      }, 2000)

    }

  var div =
    $('<div>')
    .addClass('slideshow')
    .css({
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
    })

  next()

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/components/slideshow/slideshow.js